import React from "react";
import { Box, Typography, List, ListItem, Button, Divider, Grid } from "@mui/material";

import Footer from "../components/Footer";

function HomePage() {
  return (
    <Box>
      {/* Header */}
      

      {/* Tool List */}
      

      {/* Footer */}
   
    </Box>
  );
}

export default HomePage;
